// extracted by mini-css-extract-plugin
export default {"ctaWrapper":"zZ-z","subtitle":"AZ-z","wrapper":"BZ-z","leftArrow":"CZ-z","rightArrow":"DZ-z"};